import React from "react";

const TenantAnalytics = () => {
  return <div>TenantAnalytics</div>;
};

export default TenantAnalytics;
